export const capitalizeDirective = {
    mounted(el: HTMLElement) {
        el.addEventListener('keyup', (e: any) => {
            e.target.value = e.target.value.charAt(0).toUpperCase() + e.target.value.slice(1);
        });
    },
};
